import Dashboard from "layouts/dashboard";
import Notifications from "layouts/notifications";
import SignIn from "layouts/authentication/sign-in";
import PrivateRoute from "./components/PrivateRoute";
import UserManagement from "layouts/users";
import Subscriptions from "layouts/subscription";

// @mui icons
import Icon from "@mui/material/Icon";
import ReportsManagement from "layouts/content";
import PromotionalVideos from "layouts/promotional";
import UploadedVideos from "layouts/uploaded";
import IndexManagement from "layouts/indexes";
import InfoLinkManagement from "layouts/infoLink";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "User Management",
    key: "users",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/users",
    component: (
      <PrivateRoute>
        <UserManagement />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Video Management",
    key: "uploaded",
    icon: <Icon fontSize="small">video_library</Icon>,
    route: "/uploaded",
    component: (
      <PrivateRoute>
        <UploadedVideos />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Reported Content",
    key: "content",
    icon: <Icon fontSize="small">flag_circle</Icon>,
    route: "/content",
    component: (
      <PrivateRoute>
        <ReportsManagement />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Promotional Videos",
    key: "promotional",
    icon: <Icon fontSize="small">featured_video</Icon>,
    route: "/promotional",
    component: (
      <PrivateRoute>
        <PromotionalVideos />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Subscriptions",
    key: "subscription",
    icon: <Icon fontSize="small">paid</Icon>,
    route: "/subscription",
    component: (
      <PrivateRoute>
        <Subscriptions />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "InfoLink Management",
    key: "infoLink",
    icon: <Icon fontSize="small">add_link</Icon>,
    route: "/infoLink",
    component: (
      <PrivateRoute>
        <InfoLinkManagement />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Index Management",
    key: "indexes",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/indexes",
    component: (
      <PrivateRoute>
        <IndexManagement />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: (
      <PrivateRoute>
        <Notifications />
      </PrivateRoute>
    ),
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
